module.exports = __webpack_public_path__ + "img/jam05.d471837b.jpg";